export const CAPTCHA_NEEDED = 'CAPTCHA_NEEDED';
export const CAPTCHA_SET = 'CAPTCHA_SET';
export const CAPTCHA_CANCEL = 'CAPTCHA_CANCEL';
export const CAPTCHA_SUBMITED = 'CAPTCHA_SUBMITED';



// WEBPACK FOOTER //
// ./src/constants/Captcha.js